import { motion } from "framer-motion";

export const ProductsStorage = () => (
  <section data-testid="products-storage-section" className="bg-baseLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl lg:col-span-5"
        >
          <h2
            data-testid="products-storage-headline"
            className="font-heading text-[30px] font-semibold leading-tight text-ink sm:text-[35px] lg:-mr-10 lg:whitespace-nowrap lg:text-[41px]"
          >
            Power when you need it.
            <br className="hidden lg:block" />
            Duration when you need it
          </h2>
          <p data-testid="products-storage-text" className="mt-[32px] lg:mt-5 text-[15px] leading-relaxed text-inkSoft">
            Battery buffering supports fast, short-duration response, while the hydrogen system
            provides an additional energy reserve for longer periods of low renewable generation
            or extended outages.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          data-testid="products-storage-scale"
          className="lg:col-span-7 lg:w-4/5 lg:ml-auto"
        >
          <div className="flex items-baseline justify-between">
            <div>
              <span className="text-xs font-medium uppercase tracking-[0.12em] text-inkMuted">Battery</span>
              <div className="mt-1.5 text-base font-medium text-ink lg:text-lg">Seconds → Hours</div>
            </div>
            <div className="text-right">
              <span className="text-xs font-medium uppercase tracking-[0.12em] text-inkMuted">Hydrogen System</span>
              <div className="mt-1.5 text-base font-medium text-ink lg:text-lg">Hours → Days</div>
            </div>
          </div>
          <div className="mt-5 flex h-1 w-full overflow-hidden rounded-full">
            <div className="h-full w-2/5 bg-ink/15" />
            <div className="h-full w-3/5 bg-teal" />
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
